export function installSessionExpiry(axios, browser = window) {
  return axios.interceptors.response.use(response => response, error => {
    const token = browser.localStorage.getItem('token');
    const headers = error.config?.headers;
    const authorization = headers?.Authorization || headers?.get?.('Authorization');
    if (error.response?.status === 401 && token && authorization === `Bearer ${token}`) {
      for (const key of ['token', 'isLogin', 'isLevel']) browser.localStorage.removeItem(key);
      browser.location.replace(browser.location.origin + (process.env.BASE_URL || '/'));
    }
    return Promise.reject(error);
  });
}
